import { forwardRef, useState, useEffect } from 'react';
import Calendar from 'react-multi-date-picker';
import Footer from 'react-multi-date-picker/plugins/range_picker_footer';
import calendarStyles from '../css/calendar.module.scss';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import { useTranslation } from 'react-i18next';

const CustomCalendar = forwardRef<
  HTMLDivElement,
  {
    dateValues: any[];
    handleDateChange: (value: any) => void;
    onCancel: () => void;
    fullWidth?: boolean;
    fullHeight?: boolean;
    showHours?: boolean;
  }
>(({ dateValues, handleDateChange, onCancel, fullWidth = false, fullHeight = false, showHours }, ref) => {
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const formatDate = (date: any) => {
    if (!date) return '';

    if (date && date.toDate) {
      return date.toDate().toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
    }

    if (date instanceof Date) {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
    }

    return '';
  };

  return (
    <Calendar
      value={dateValues}
      onChange={handleDateChange}
      range
      numberOfMonths={isMobile ? 1 : 2}
      rangeHover={!isMobile}
      plugins={[
        <Footer
          position="bottom"
          format="DD/MM/YYYY"
          names={{
            selectedDates: t('customCalendar.selectDates'),
            from: '',
            to: '',
            selectDate: t('customCalendar.selectDate'),
            close: t('customCalendar.close'),
            separator: `${isMobile ? '' : '-'}`,
          }}
        />,
        ...(showHours ? [<TimePicker position={isMobile ? 'top' : 'right'} hStep={1} mStep={1} sStep={1} />] : []),
      ]}
      render={(value, openCalendar) => (
        <div className={`${calendarStyles.wrapper} ${fullWidth ? calendarStyles.fullWidth : ''} ${fullHeight ? calendarStyles.fullHeight : ''}`} ref={ref}>
          <div
            className={calendarStyles.calendarInput}
            onClick={() => {
              openCalendar();
            }}
          >
            <img src="/assets/images/calendar-icon.svg" alt="calendar icon" />
            <div className={calendarStyles.calendarInputRight}>
              <div>
                {dateValues[0] || dateValues[1] ? (
                  <p>
                    {formatDate(dateValues[0]) || ''} - {formatDate(dateValues[1]) || ''}
                  </p>
                ) : (
                  <p style={{ color: '#a2b1c2' }}>{t('customCalendar.newest')}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    />
  );
});

CustomCalendar.displayName = 'CustomCalendar';

export default CustomCalendar;
